import styled from "styled-components";

export const CategoryContainer = styled.article`
  padding: 4rem 0 2rem;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: auto;
  box-sizing: border-box;
`;

export const CategoryHeading = styled.h3`
  text-align: center;
  width: 100%;
  font-size: 40px;
  color: ${props => props.fontColor || "#000000"};

  @media screen and (min-width: 767px) {
    font-size: 40px;
    margin-bottom: 3rem;
  }

  @media screen and (max-width: 766px) {
    font-size: 28px;
    margin-bottom: 2rem;
  }
`;

export const ViewMoreButton = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 50%;
`;